<template>
  <v-card class="pb-1">
      <v-card-title v-if="title" class="text-xs-center justify-center">
        <v-col :style="{color:$vuetify.theme.primary}" text-xs-center headline>{{$tf(title)}}</v-col>
      </v-card-title>
    <v-card-title v-if="subtitle" class="text-xs-center justify-center">
      <v-col :style="{color:$vuetify.theme.primary}" text-xs-center subheading>{{$tf(subtitle)}}</v-col>
    </v-card-title>
    <slot name="alert-error">
      <v-alert  v-if="errorMessage !== ''" type="error" :value="errorMessage.length > 0">
          <v-card-text class="white--text pt-0">
            <span v-if="errorMessage !== '' && errorTextParam"  >{{$tf(errorMessage, errorTextParam)}}</span>
            <span v-else-if="errorMessage !== ''" >{{$tf(errorMessage)}}</span>
          </v-card-text>
      </v-alert>
    </slot>
    <slot name="alert-warning">
      <v-alert  v-if="warningMessage !== ''" type="warning" :value="warningMessage.length > 0">
          <v-card-text class="white--text pt-0"><span>{{$tf(warningMessage)}}</span></v-card-text>
          <v-card-text class="white--text pt-0" v-if="warningLink">
            <a class="white--text font-weight-medium" @click="$emit('link-clicked')">
              {{$tf(warningLink)}}
            </a>
          </v-card-text>
      </v-alert>
    </slot>
    <slot name="alert-info"></slot>
    <v-card-text class="body-1 pb-0" v-if="cardText ||formId!==''">
      <span v-if="cardText!=='' && cardTextParam !==''">{{$tf(cardText, cardTextParam)}}</span>
      <span v-else-if="cardText!==''">{{$tf(cardText)}}</span>
      <v-form class="px-4" :action="formAction" method="POST" v-if="formId!==''" v-on:submit.prevent ref="form" :id="formId" lazy-validation>
        <input type="hidden"
               :value="locale"
               name="hl"
        >
        <input type="hidden"
               :value="explicitLocale"
               name="hl_explicit"
        >
        <input type="hidden"
               :value="$wlDomain"
               name="wl"
        >
        <slot name="form-fields">
        </slot>
      </v-form>
    </v-card-text>
    <v-card-actions class="pb-4 pt-0" v-if="mainAction">
      <v-container justify="space-between" >
      <v-row wrap justify="end">
        <v-col v-if="secondaryAction" cols="12" :sm="secondaryButtonWidth" :class="$vuetify.breakpoint.xs? 'mt-2':''"  order="2" order-sm="1">
            <v-btn text style="width:inherit" :block="$vuetify.breakpoint.xs" color="primary" @click="$root.$emit('do',secondaryAction)">{{$tf(secondaryActionText)}}</v-btn>
        </v-col>
        <v-col cols="12" :sm="mainButtonWidth" order="1" order-sm="2">
            <v-btn
              :style="$machine.browser==='ie'? 'color:black!important;':''"
              style="width:inherit"
              :block="$vuetify.breakpoint.xs"
              color="accent"
              @click="$root.$emit('do',mainAction)">
              {{$tf(mainActionText)}}</v-btn>
        </v-col>
      </v-row>
      </v-container>
    </v-card-actions>
    <slot name="extra">
    </slot>
  </v-card>
</template>

<script>
import { getExplicitLocale } from '../../mixins/locale'
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    formId: {
      type: String,
      default: ''
    },
    formAction: {
      type: String,
      default: ''
    },
    cardText: {
      type: String,
      default: ''
    },
    mainAction: {
      type: String,
      default: ''
    },
    secondaryAction: {
      type: String,
      default: ''
    },
    mainActionText: {
      type: String,
      default: ''
    },
    secondaryActionText: {
      type: String,
      default: ''
    },
    extraContent: {
      type: Boolean,
      default: false
    },
    warningMessage: {
      type: String,
      default: ''
    },
    warningLink: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    },
    refresh: {
      type: String,
      default: ''
    },
    cardTextParam: {
      type: Object,
      default: null
    },
    errorTextParam: {
      type: Object,
      default: null
    },
    mainButtonWidth: {
      type: Number,
      default: 5
    },
    secondaryButtonWidth: {
      type: Number,
      default: 5
    }
  },
  computed: {
    locale () {
      return this.$root.$i18n.locale
    },
    explicitLocale () {
      return getExplicitLocale() === this.locale ? this.locale : ''
    }
  },
  watch: {
    refresh (val) {
      this.$forceUpdate()
    }
  },
  beforeMount () {
    let self = this
    this.$root.$on('reset', () => {
      self.$refs.form.resetValidation()
    })
    window.addEventListener('keydown', this.keyDown)
  },
  destroyed: function () {
    window.removeEventListener('keydown', this.keyDown)
  },
  data () {
    return {
      isTouchable: this.$machine.isTouchable
    }
  },
  methods: {
    keyDown (e) {
      let key = e.key || e.code || e.keyCode
      if (key === 'Enter' || key === 'NumpadEnter' || key === 13) {
        this.$root.$emit('do', this.mainAction)
      }
    }
  }
}
</script>

<style scoped>

</style>
